/**
 * Frontpage component.
 * @module components/Frontpage/Frontpage
 */
import { BodyClass, hasBlocksData } from '@plone/volto/helpers';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { Onboarding } from './'


const Frontpage = (props) => {
  const { content } = props;

  return (
    <>
      <BodyClass className="frontpage noBreadcrumbs" />

      <div className="visually-hidden">
        <h1>{content.title}</h1>
      </div>

      <Onboarding {...props} />

      {hasBlocksData(content) ? (
        <div className="userBlocks">
          <RenderBlocks {...props} />
        </div>
      ) : null}
    </>
  );
};

export default Frontpage;
